module.exports = __webpack_public_path__ + "static/media/logo.48adc754.png";